<template>
  <div class="col-lg-8 mx-auto overflow-x-hidden">
    <header class="text-center">
      <workflow-navigation workflowStage="Haves" />
      <h2 class="skin-page-heading">
        What you have to put towards retirement
      </h2>
      <p class="px-3">
        {{ subHeadingText }}
        <help
          title="What different parts can you put towards your retirement income?"
          :text="htmlArray('haves.help')"
          :isWide="true"
        />
      </p>
    </header>

    <assets />

    <page-nav backLink="requirements" @nextClicked="onNextClicked" :parent-will-handle-next="true" :next-link="nextLink" />

    <contact-us class="mt-5"></contact-us>
  </div>

  <modal
    ref="noPotsModal"
    idKey="NoPensionsWarning"
    title="No pension pots added"
  >
    <p>
      We can show you how to take money from your pension pots along with
      everything else to get what you want, we would expect you would want to
      add at least one?
    </p>
  </modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import WorkflowNavigation from "@/guiide/components/common/WorkflowNavigation.vue";
import Help from "@/guiide/components/common/Help.vue";
import Assets from "@/guiide/components/assets/Assets.vue";
import ContactUs from "./common/ContactUs.vue";
import PageNav from "@/guiide/components/common/PageNav.vue";
import Modal from "@/guiide/components/common/Modal.vue";
import { PensionPot } from "../ts/pensionPot";
import { workflow } from "../ts/workflow/workflow";
import View from "../ts/view";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

export default defineComponent({
  name: "Income",
  components: {
    WorkflowNavigation,
    Help,
    Assets,
    ContactUs,
    PageNav,
    Modal
  },
  data() {
    const nextLink = ref("");

    return {
      noPotsWarningShown: false,
      nextLink
    };
  },
  setup() {
    const userCode = ref(null);
    const noPotsModal = ref(null);
    const { htmlArray } = useUIContent();

    return {
      userCode,
      noPotsModal,
      htmlArray
    };
  },
  async mounted() {
    const nextWorkflowStep = await workflow.getNextWorkflowStep(View.Haves);
    this.nextLink = nextWorkflowStep.resource;
  },
  computed: {
    subHeadingText: function(): string {
      return this.$store.state.configuration.havesSubHeadingText;
    },
    warnWhenNoPensionPots: function (): boolean {
      return this.$store.state.configuration.havesWarnWhenNoPensionPots;
    }
  },
  methods: {
    onNextClicked() {
      const pensionPots =
        this.$store.state.retiree?.pensionPots.pots ?? new Array<PensionPot>();

      if (this.warnWhenNoPensionPots && !this.noPotsWarningShown && pensionPots.length == 0) {
        this.noPotsModal.showModal();
        this.noPotsWarningShown = true;
        return;
      }

      workflow.goToNextWorkflowStep();
    }
  }
});
</script>
